import { render, staticRenderFns } from "./DragDropFileUploader.vue?vue&type=template&id=513fb6a9&scoped=true&"
import script from "./DragDropFileUploader.vue?vue&type=script&lang=js&"
export * from "./DragDropFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./DragDropFileUploader.vue?vue&type=style&index=0&id=513fb6a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513fb6a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VFileInput,VIcon,VSheet})
